import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Service } from 'data/terra/Service';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { CommonState } from '../reducer';

export const FETCH_SERVICES = 'FETCH_SERVICES';

export interface FetchServicesAction {
  type: typeof FETCH_SERVICES;
  services: Service[];
}

export const fetchServices = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  const result = await Terra.service.fetchServices();
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_SERVICES,
      services: result.get()!.data,
    } as FetchServicesAction);
  }

  return result;
};

export const fetchServicesDelegate: DelegateMapEntry<
  FetchServicesAction,
  CommonState
> = {
  [FETCH_SERVICES]: (
    state: CommonState,
    action: FetchServicesAction
  ): CommonState => {
    return {
      ...state,
      services: action.services,
    };
  },
};
